import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const variation = RepositoryFactory.get("variation");

export default {
    getVariations({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await variation.getVariations(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addVariations({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await variation.addVariations(payload)
        commit("Add_Variation", data.data);

                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editVariations({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await variation.editVariations(payload)
      
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}